import { Colors, mediaQueries } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  background: linear-gradient(#d82792, #3621b6);
  background: radial-gradient(115.04% 128.1% at 96.27% -10.78%, #d82792 0%, #3621b6 100%);

  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 280px;
  overflow: hidden;

  ${mediaQueries.tablet} {
    max-height: none;
    max-width: 500px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 0 36px 0;

    ${mediaQueries.tablet} {
      padding: 0;
    }
  }

  .swiper-pagination {
    width: fit-content !important;
    left: auto !important;
    right: 12px !important;
    bottom: 12px !important;

    ${mediaQueries.tablet} {
      right: 16px !important;
      bottom: 16px !important;
    }
  }

  .swiper-pagination-bullet {
    width: 6px !important;
    height: 6px !important;
    transition: opacity 0.3s ease-in-out;
    background: ${Colors.GS100} !important;

    ${mediaQueries.tablet} {
      width: 8px !important;
      height: 8px !important;
    }
  }
`;
export const SlideImage = styled.img `
  max-height: 80%;
  margin: 16px 0;

  ${mediaQueries.tablet} {
    margin: 24px 0;
    padding: 0 24px;
    width: 356px;
    max-width: 100%;
  }
`;
export const SlideTitle = styled.div `
  margin: 0 20px;
  text-align: center;
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
  color: #ffffff;

  ${mediaQueries.tablet} {
    font-size: 14px;
    line-height: 20px;
  }
`;
